import React, { Component } from "react";
import Flexbox from "flexbox-react";
import Button from "./../Button";
import popup from "./../../actions/popup";
import { connect } from "react-redux";
import authActions from "../../actions/auth";
import { Form, Input } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import messages from "./messages";
import ls from "local-storage";
import { Row, Spin, Icon } from "antd";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin/>;
const FormItem = Form.Item;

const FormBlock = ({ onChange, getFieldDecorator, formatMessage, enterEmail }) => (
	<Form style={{ width: "90%" }} onChange={onChange}>
		<FormItem>
			{getFieldDecorator("email", {
				initialValue: `${enterEmail}`,
				rules: [
					{
						type: "email",
						required: true,
						message: formatMessage(messages.emailInValid)
					},
					{
						message: formatMessage(messages.email)
					}
				]
			})(<Input placeholder={formatMessage(messages.placeholder)}/>)}
		</FormItem>
	</Form>
);

const PopupClose = ({ children }) => (
	<Flexbox flexDirection="column" flex="1" className="Popup">
		<Flexbox justifyContent="flex-end">
			<Button type="close-popup" onClick={() => popup.close()}>X</Button>
		</Flexbox>
		{children}
	</Flexbox>
);

const CreditCard = () => (
	<Flexbox flexDirection="column"
	         justifyContent="center"
	         alignItems="center"
	         style={{ margin: "auto", width: "90%" }}>
		<h2>
			<FormattedMessage {...messages.titleCard} />
		</h2>
		<h4>
			<FormattedMessage {...messages.subtitleCard} />
		</h4>
	</Flexbox>
);

class Popup extends Component{
	constructor(props) {
		super(props);
		this.state = {
			enterEmail: ls.get("email") || ""
		};
	}
	
	componentWillReceiveProps({ auth }) {
		if (!this.props.auth && auth) {
			authActions.getUserById(auth);
		}
	}
	
	validateField = () => {
		this.props.form.validateFieldsAndScroll((err, values) => {
			if (!err && values.email) {
				this.setState({
					enterEmail: values.email
				});
			} else {
				this.setState({
					enterEmail: ""
				});
			}
		});
	};
	onChange = (e) => {
		e.preventDefault();
		this.validateField();
	};
	buy = () => {
		const { enterEmail } = this.state;
		this.props.form.validateFieldsAndScroll((err, values) => {
			if (!err && values.email) {
				authActions.buy(enterEmail);
				ls.set("email", enterEmail);
				popup.close();
			}
		});
	};
	
	render() {
		const { form: { getFieldDecorator }, intl: { formatMessage }, isLoading, type } = this.props;
		const { enterEmail } = this.state;
		
		if (isLoading) {
			return (
				<Row type='flex' justify='center' align='middle' className='Spin'>
					<Spin indicator={antIcon}/>
				</Row>
			);
		}
		return (
			<PopupClose>
				{
					<Flexbox flexDirection="column"
					         justifyContent="center"
					         alignItems="center"
					         style={{ margin: "auto", width: "90%" }}>
						<h2>{formatMessage(messages[`title${type}`])}</h2>
						<h4>{formatMessage(messages[`subtitle${type}`])}</h4>
						<FormBlock onChange={this.onChange} getFieldDecorator={getFieldDecorator}
						           formatMessage={formatMessage} enterEmail={enterEmail}/>
						<Button
							type="primary"
							onClick={this.buy}>
							{formatMessage(messages.button)}
						</Button>
					</Flexbox>
				}
			</PopupClose>
		);
	}
}

const mapStateToProps = ({ user: { email, auth, uid, isLoading } }) => {
	return {
		email, auth, uid, isLoading
	};
};

export default injectIntl(connect(mapStateToProps)(Form.create()(Popup)));



// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js